/**
 * @Description
 */

import { FC } from 'react';
import styles from './index.module.less';
import { ClockCircleFilled, EnvironmentTwoTone } from '@ant-design/icons';
import { post } from '@/common/request';

const PageOne:FC<any> = ({ data, nameObj, qrCode }) => {

  const download = () => {
    post('/html2img', { url: 'http://192.168.89.124:8003/business/recommend', clip: { x: 0, y: 0, width: 800, height: 640 } }, { proxyApi: '/testpdf' }).then((res) => {
      const { data } = res;
      window.open(data?.url);
    });
  };

  return (
    <div className={styles['page']}>
      <div className={styles['left']}>
        <div className={styles['left-content']}>
          <div className={styles['title']}>
            <div className={styles['title-tag']} onClick={download}>【市场调研】</div>
            <div className={styles['title-content']}>{nameObj?.name || '-'}</div>
          </div>

          <div className={styles['divider']}></div>

          <div className={styles['detail']}>
            <div className={styles['detail-time']}>
              <ClockCircleFilled className={styles['detail-time__icon']}/>
              {data?.searchTime || '-'}
            </div>
            <div className={styles['detail-loc']}>
              <EnvironmentTwoTone className={styles['detail-loc__icon']} twoToneColor='#E6F0FF'/>
              {nameObj?.rangeName || '-'}
            </div>
          </div>
        </div>
      </div>

      <div className={styles['right']}>
        <div className={styles['code']}>
          <img src={qrCode} className={styles['code-img']}/>
          <div className={styles['code-title']}>LOCATION商业直租</div>
        </div>
      </div>
    </div>
  );
};

export default PageOne;
